/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Approved_LabelInputs */

const en_samples_approved_label = /** @type {(inputs: Samples_Approved_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approved`)
};

const es_samples_approved_label = /** @type {(inputs: Samples_Approved_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobada(s)`)
};

/**
* | output |
* | --- |
* | "Approved" |
*
* @param {Samples_Approved_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_approved_label = /** @type {((inputs?: Samples_Approved_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Approved_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_approved_label(inputs)
	return es_samples_approved_label(inputs)
});